module.exports = __webpack_public_path__ + "images/emoji/unlock.edc7d809cc90050cf398.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/unlock.png
// module id = pB9s
// module chunks = 1